import React, { useEffect } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

function Incidents() {
  useEffect(() => {
    document.title = 'Fleet Incidents - Sales Assist';
    return () => {
      document.title = 'Sales Assist';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-lg bg-red-100">
            <ExclamationTriangleIcon className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Fleet Incidents</h1>
            <p className="text-sm text-gray-600 mt-1">Manage and track fleet incidents and accidents</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-6">
        <div className="px-6">
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-12 text-center">
            <div className="max-w-md mx-auto">
              <ExclamationTriangleIcon className="w-20 h-20 text-gray-300 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Incident Management Coming Soon</h2>
              <p className="text-gray-600 mb-6">
                The incident management system is currently under development. This feature will allow you to:
              </p>
              <ul className="text-left text-gray-600 space-y-2 mb-8">
                <li className="flex items-start">
                  <span className="text-red-600 mr-2">•</span>
                  <span>Report and track vehicle incidents</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-2">•</span>
                  <span>Upload incident photos and documents</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-2">•</span>
                  <span>Assign incidents to drivers</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-2">•</span>
                  <span>Track incident resolution status</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-600 mr-2">•</span>
                  <span>Generate incident reports</span>
                </li>
              </ul>
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-sm text-red-800">
                  <strong>Note:</strong> This feature will be available in a future update.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Incidents;











